import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { goBack, push } from 'connected-react-router';
import { createStructuredSelector } from 'reselect';
import Header from './components/Header';
import { Route, Switch } from 'react-router';
import { withRouter } from 'react-router-dom';
import { selectors as config } from '../modules/config';
import { selectors as ui } from '../modules/ui';
import { selectors as user } from '../modules/user';
import { auth0Service } from '../common/bootstrap';
import Home from './home/Home';
import Error from './error/Error';
import Profile from './customer/Profile';

const Main = ({ location, onLogoutHandler, title, version, children, redirect, match }) => {
    auth0Service.on('ready_to_redirect', next => {
        redirect(next);
    });

    const onLogin = () => auth0Service.login(location.pathname + location.search);
    const onLogout = () => onLogoutHandler(auth0Service.logout);

    return (
        <div>
            <Header
                onLogout={onLogout}
                onLogin={onLogin}
                title={title}
                version={version}
                isLoggedIn={auth0Service.loggedIn()}
                user={auth0Service.getProfile()} />
            <main>
                {auth0Service.loggedIn() &&
                    <Switch>
                        <Route exact path="/" component={Home} ></Route>
                        <Route path="/customer/:id" component={Profile}></Route>
                    </Switch>
                }
                {!auth0Service.loggedIn() &&
                    <div className="container alert alert-warning">
                        Please log in
                    </div>
                }
            </main>
        </div>
    )
};

Main.propTypes = {
    onLogoutHandler: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    user: PropTypes.object.isRequired,
    version: PropTypes.string.isRequired,
    redirect: PropTypes.func.isRequired
};

const mapStateToProps = createStructuredSelector({
    title: ui.getTitle,
    user: user.get,
    version: config.getVersion,
    location: ui.getLocation
});

const mapDispatchToProps = (dispatch, props) => ({
    onLogoutHandler: logout => {
        logout();
        //dispatch(push('/'));
    },
    redirect: next => dispatch(push(next))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Main));